import type {
  GetMbcCatalogResponse,
  ListMbcAdminAssignmentsResponse,
  MbcAdminGuideline,
} from "@nlc/shared-types";

import { useAssignments } from "./design-types/hooks/useAssignments";
import { useMbcCatalog } from "./design-types/hooks/useMbcCatalog";
import { useGuidelines } from "./guidelines/hooks/useGuidelines";

interface MbcAdminData {
  assignments?: ListMbcAdminAssignmentsResponse;
  catalog?: GetMbcCatalogResponse;
  error?: Error;
  guidelines?: MbcAdminGuideline[];
  isLoading: boolean;
}

export function useMbcAdminData(): MbcAdminData {
  const catalog = useMbcCatalog();
  const assignments = useAssignments();
  const guidelines = useGuidelines();
  const queries = [catalog, assignments, guidelines];

  return {
    assignments: assignments.data,
    catalog: catalog.data,
    error: queries.find((query) => query.error)?.error ?? undefined,
    guidelines: guidelines.data,
    isLoading: queries.some((query) => query.isLoading),
  };
}
